import { useShopperContext } from '@salesforce/commerce-sdk-react/hooks/ShopperContexts';
import type { ShopperContextsTypes } from 'commerce-sdk-isomorphic';
import { useIsPreviewMode } from './useIsPreviewMode';
import { useUsidGet } from './useUsidGet';

export const useShopperContextGet = (): ShopperContextsTypes.ShopperContext | null => {
    const usidQuery = useUsidGet();
    const isPreviewMode = useIsPreviewMode();
    const { data: shopperContext } = useShopperContext(
        {
            parameters: {
                usid: usidQuery.data ?? '',
            },
        },
        {
            enabled: !!usidQuery.data && isPreviewMode,
        },
    );
    return shopperContext ?? null;
};
